<script>
import {mapGetters, mapActions} from 'vuex';

import {FORM_DATA_VALUES} from '@/modules/constants';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import {textShortener} from '@/libs/utils';
import Tooltip from '@/modules/first-form/components/tooltip/Tooltip.vue';
import {getEuropeanDate} from '../../libs/utils';
import appConfig from '@/configs/app.config';
import FormSponsorTexts from "@/modules/first-form/components/FormSponsorTexts.vue";
import IkPopup from '@/components/ik-popup/IkPopup.vue';
import ObPopup from "@/components/ob-popup/ObPopup.vue";

const DEFAULT_STANDARD_LENGTH = 'Länge in m';
const DEFAULT_REASON = 'Privatumzug';
const FORM_ERRORS = {
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  ZIP: 'zip',
  LENGTH: 'length'
};

export default {
  name: 'FirstStep',

  components: {ObPopup, IkPopup, Tooltip, DatePicker, FormSponsorTexts},
  data() {
    return {
      FORM_DATA_VALUES,
      isMobile: false,
      moreAs25Meter: false,
      hideForm: true,
      formError: null,
      showReasonTooltip: false,
      formData: {
        zipCode: '',
        reason: '',
        length: '',
        dateFrom: '',
        dateTo: '',
        street: '',
        streetNr: '',
        timeStart: '',
        timeEnd: '',
        secondFormEnabled: false
      },
      formDataState: {
        zipCode: '',
        reason: DEFAULT_REASON,
        length: DEFAULT_STANDARD_LENGTH,
        dateFrom: '',
        dateTo: ''
      },
      isFormValid: false,
      variant: -1,
      isInlineForm1: false
    };
  },
  computed: {
    ...mapGetters(['priceInfo', 'priceNotExists', 'step', 'inlineForm', 'reasonOptions', 'selectionPopupZipId', 'selectionPopupLevel', 'fromUrl', 'showIkModal']),
    //In welcher PLZ brauchen Sie die Zone?
    zipCodePlaceHolder: function() {
      return this.isMobile && window.innerWidth < 761 ? 'PLZ' : 'PLZ';

    },

    renderLengthValue() {
      return this.formDataState.length === DEFAULT_STANDARD_LENGTH
        ? DEFAULT_STANDARD_LENGTH
        : this.formDataState.length + ' Meter';
    },
    formContainerStyles() {
      return this.isInlineForm1
        ? {  }
        : { padding: '0px !important', background: 'transparent !important' };
    },
  },
  beforeMount() {
    let subUrl = window.location.href;
    if (subUrl.includes('halteverbotszone-kuechenanlieferung-lp-ik.html')) {
      this.$store.commit('SET_SHOW_IK_MODAL', true);
    }else{
      this.$store.commit('SET_SHOW_IK_MODAL', false);
    }
    if (subUrl.includes('halteverbotszone-kuechenanlieferung-lp-ob.html')) {
      this.$store.commit('SET_SHOW_OB_MODAL', true);
    }else{
      this.$store.commit('SET_SHOW_OB_MODAL', false);
    }
  },
  mounted() {
    if (this.$root.$el.classList.contains("inline-form1")) {
      this.formDataState.reason = 'Küchenlieferung / Möbellieferung';
      this.isInlineForm1 = true;
    }
  },
  updated() {
    this.isMobile = this.$store.getters.isMobile;
    this.moreAs25Meter = this.formData.length === FORM_DATA_VALUES.LONGER_THAN_25_METERS;
    if (this.priceInfo && this.formDataState.length === DEFAULT_STANDARD_LENGTH) {
      this.formDataState.length = this.priceInfo.standard_laenge
        ? this.priceInfo.standard_laenge[0]
        : DEFAULT_STANDARD_LENGTH;
    }
    if (
      this.priceInfo &&
      this.formDataState.zipCode !== '' &&
      this.formDataState.dateTo &&
      this.formDataState.dateFrom &&
      this.formDataState.reason !== 'Dreharbeiten'
    ) {
      this.isFormValid = true;
    }
    if (this.formDataState.reason === 'Dreharbeiten') {
      this.showReasonTooltip = true;
      this.isFormValid = false;
    }
  },
  methods: {
    ...mapActions([
      'getPriceInfoAction',
      'setExistsPriceAction',
      'setFormDataAction',
      'resetPriceInfoAction',
      'setIsFormDetailsEditAction',
      'resetStoreAction',
    ]),

    onFormChange: function() {
      this.$store.commit('SET_SELECTION_POPUP_ZIPID', null);
      this.$store.commit('SET_SELECTION_POPUP_LEVEL', 1);

      if (this.formDataState.zipCode.length === 5) {
        this.resetPriceInfoAction();
        this.formDataState.length = DEFAULT_STANDARD_LENGTH;

        this.getPriceInfoAction({ zipcode: this.formDataState.zipCode, priceForSecondForm: false });
      } else {
        this.isFormValid = false;
        if (this.priceInfo) {
          this.resetPriceInfoAction();

          this.formDataState.length = DEFAULT_STANDARD_LENGTH;
        }

        this.moreAs25Meter = false;

        this.formError = this.formError === FORM_ERRORS.ZIP ? null : this.formError;
        this.setExistsPriceAction(false);
      }
    },

    onFormSubmit: function() {
      if (!this.formDataState.zipCode) {
        this.formError = FORM_ERRORS.ZIP;
        return;
      }

      if (!this.formDataState.dateFrom) {
        this.formError = FORM_ERRORS.DATE_FROM;
        return;
      }

      if (!this.formDataState.dateTo) {
        this.formError = FORM_ERRORS.DATE_TO;
        return;
      }

      if (new Date(this.formDataState.dateTo) < new Date(this.formDataState.dateFrom)) {
        this.formError = FORM_ERRORS.DATE_TO;
        return;
      }

      if (this.formDataState.length === DEFAULT_STANDARD_LENGTH) {
        this.formDataState.length = this.priceInfo.standard_laenge[0];
      }
      if (this.formDataState.reason === 'Dreharbeiten') {
        return;
      }

      if (this.inlineForm === true) {
        let link = appConfig.redirectUrl + `?plz=${this.formDataState.zipCode}&dateFrom=${this.formDataState.dateFrom}` +
          `&dateTo=${this.formDataState.dateTo}&length=${this.formDataState.length}&reason=${this.formDataState.reason}` +
          `&zipId=${this.selectionPopupZipId}&zipLevel=${this.selectionPopupLevel}&fromUrl=${this.fromUrl}`;
        this.resetStoreAction();
        window.open(link, '_self');
        return;
      }
    },

    onDateSelect: function (date, name) {

      if (date.includes('/')) {
        date = getEuropeanDate(date);
      }

      this.formDataState[name] = date;

      if ((name === 'dateFrom') && !this.formDataState.dateTo) {
        this.formDataState.dateTo = date;
      }
      let from = this.formDataState.dateFrom.split(".");
      let to = this.formDataState.dateTo.split(".");

      // Check if dateTo is past of dateFrom
      if (this.formDataState.dateTo && this.formDataState.dateFrom) {
        let dateObjFrom = new Date(from[2], from[1] - 1, from[0]);
        let dateObjTo = new Date(to[2], to[1] - 1, to[0]);

        if (dateObjTo < dateObjFrom) {
          this.formDataState.dateTo = '';
          alert('Das Enddatum darf nicht in der Vergangenheit liegen. Bitte geben Sie ein korrektes Datum an.');
          this.formError = FORM_ERRORS.DATE_TO;
        }
      }
    },

    onDateFieldClick: function () {
      if (this.formDataState.dateTo < this.formDataState.dateFrom) {
        this.formDataState.dateTo = this.formDataState.dateFrom;
      }
      this.setExistsPriceAction(false);
    },

    onDateShow: function () {
      this.formError = null;
    },

    hidePopups: function () {
      this.formDataState.reason = DEFAULT_REASON;
      this.showReasonTooltip = false;
    },
    // imported helpers
    textShortener,
    toggle25meter: function (state) {
      this.formData.length = DEFAULT_STANDARD_LENGTH;
      if (state) {
        this.formData.length = FORM_DATA_VALUES.LONGER_THAN_25_METERS;
      }
      this.moreAs25Meter = state;
    },
    focusOnPlz: function () {
      this.hideForm = false;
      this.$nextTick(() => {
        if (this.$refs.plz) this.$refs.plz.focus();
        window.scrollTo(0, -100);
      });
    }
  }
};
</script>

<template>
  <div :class="!this.isInlineForm1 ?  'inline-first-page' : 'inline-first-page1'">
    <IkPopup pop-up-headline="In welchem Haus / Studio haben Sie Ihre Küche bestellt?" />
    <ObPopup pop-up-headline="In welchem Haus / Studio haben Sie Ihre Küche bestellt?" />
    <div :class="!this.isInlineForm1 ? 'form-container inline-form-wrapper' : 'form-container1 inline-form-wrapper'" :style="formContainerStyles">
      <div class="form-content">
        <h3 v-if="!isInlineForm1" class="form-head" style="font-weight: normal !important;">Jetzt hier Halteverbotzone bestellen</h3>
        <div class="mb-xs-10 text-right" style="cursor: pointer">
          <i
            @click="
              hideForm = true;
              formDataState.zipCode = '';
            "
            class="fa fa-times visible-xs mobile-close-modal pr-xs-10"
          />
        </div>
        <div class="form-inputs" style="display: block !important;">
          <div class="form-input-item field-zip-code c-fl-left" style="position:relative;">
            <input
              ref="plz"
              required
              class="zip-code"
              maxlength="5"
              type="text"
              pattern="\d*"
              :placeholder="zipCodePlaceHolder"
              value=""
              @input="onFormChange"
              v-model="formDataState.zipCode"
              data-toggle="popover"
              data-content=""
              title=""
              data-trigger="manual"
              data-placement="bottom"
              data-html="true"
              data-original-title=""
            />

            <div style="position:relative !important;">
              <tooltip :visible="priceNotExists" :variant="Number(this.variant)"/>
              <tooltip :visible="formError === 'zip'" :variant="Number(this.variant)" :is-error="true" text="Füllen Sie dieses Feld aus."/>
            </div>
          </div>
          <div class="date-fields-item c-fl-left">
            <date-picker
              input-id="datepicker-from"
              name="dateFrom"
              :value="formDataState.dateFrom"
              place-holder="Von"
              :show="formError === 'dateFrom'"
              :on-select="onDateFieldClick"
              @onDateSelected="onDateSelect"
              @onDateShow="onDateShow"
            />
          </div>
          <div class="date-fields-item c-fl-left">
            <date-picker
              :show="formError === 'dateTo'"
              input-id="datepicker-to"
              name="dateTo"
              :value="formDataState.dateTo"
              place-holder="Bis"
              :on-select="onDateFieldClick"
              @onDateSelected="onDateSelect"
              @onDateShow="onDateShow"
            />
          </div>

          <div class="c-cl">
            <div class="dropdown length-dropdown c-fl-left">
              <button
                :disabled="!this.priceInfo || !this.priceInfo.standard_laenge"
                @click="toggle25meter(false)"
                class="btn btn-default dropdown-toggle text-left"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {{ renderLengthValue }}
                <span class="fa fa-chevron-down"/>
              </button>

              <ul class="dropdown-menu" aria-labelledby="form-reason">
                <template v-if="priceInfo">
                  <li v-for="length in priceInfo.standard_laenge" :key="length">
                    <a @click="formDataState.length = length" href="javascript:void(0)"> {{ length }} Meter </a>
                  </li>
                  <li>
                    <a @click="toggle25meter(true)" href="javascript:void(0)">
                      Mehr als 25 Meter
                    </a>
                  </li>
                </template>
              </ul>
              <div style="position:relative;">
                <tooltip
                  :visible="moreAs25Meter"
                  text="Für eine Länge von mehr als 25 Metern müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser"
                />
              </div>
            </div>
            <div class="dropdown reason-dropdown c-fl-left"
              data-toggle="popover"
              data-content=""
              title=""
              data-trigger="manual"
              data-placement="bottom"
              data-html="true"
              data-original-title=""
            >
              <button
                class="btn btn-default dropdown-toggle text-left"
                @click="hidePopups"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {{ textShortener(formDataState.reason, 16) }}
                <span class="fa fa-chevron-down"/>
              </button>
              <ul class="dropdown-menu" aria-labelledby="form-length">
                <li v-for="reason in this.reasonOptions" :key="reason">
                  <a @click="formDataState.reason = reason" href="javascript:void(0)">
                    {{ reason }}
                  </a>
                </li>
              </ul>
              <div style="position: relative;">
                <tooltip
                  :visible="showReasonTooltip"
                  text="Bei Dreharbeiten müssen wir Ihnen ein gesondertes Angebot erstellen. Erfragen Sie Ihren Preis über unser "
                />
              </div>
            </div>
          </div>

          <div class="c-cl">
            <div class="form-input-item submit-btn">
              <input
                v-if="isFormValid"
                :disabled="moreAs25Meter || this.priceNotExists"
                type="submit"
                :value="!this.isInlineForm1 ? 'Jetzt Bestellen' : 'Jetzt Preis ermitteln & bestellen'"
                class="form-button"
                @click="onFormSubmit"
              />
              <input
                v-else
                :disabled="moreAs25Meter || this.priceNotExists"
                type="submit"
                class="form-button invalid"
                :value="!this.isInlineForm1 ? 'Jetzt Bestellen' : 'Jetzt Preis ermitteln & bestellen'"
                @click="onFormSubmit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- css for component styles -->
<style scoped lang="scss">
@import 'InlineFormStyles';
</style>

<!-- css for global styles -->
<style lang="scss"></style>
